e.N.my_news_feed = {
	page : 1,

	init : function(){
		$( '#news-posts' ).on( 'click', '#load-more', this._load_more );
		$( '#filter-news-feed' ).find( 'select' ).on( 'change', this._filter_posts );
	},

	_filter_posts : function(){
		var type = $(this ).val();
		var $news_posts = $( '#news-posts' );
		if( type == '' ){
			$news_posts.find( '.news-post' ).slideDown();
		} else {
			$news_posts.find( '.news-post.' + type ).slideDown();
			$news_posts.find( '.news-post' ).not( '.' + type ).slideUp();
		}

	},

	_load_more : function(){
		var $el = $( this );
		e.N.my_news_feed.page++;

		var $data = {
			method : 'get_news',
			page   : e.N.my_news_feed.page
		};

		$.post( config.api + 'news_feed', $data , function( out ){
			$el.before( out );
		} );

	}
};